import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { IntlContext, IntlProvider } from 'react-intl';
import NuDSProvider, { nuDSProviderShape } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import { ExperimentsContextProvider } from '../Experiment/ExperimentsContext';
import { requireImage } from '../../utils/requireImage';
import backgroundImage from '../Image/backgroundImage/backgroundImage';
import { customFormatMessage } from '../../utils/cms/customFormatMessage';

function WebsiteProvider(props) {
  const {
    locale,
    messages: allMessages,
    children,
    availableExperiments,
    customPolyfillFeatures,
  } = props;
  const { cms: cmsMessages, ...messages } = allMessages;
  const defaultPolyfillFeatures = [
    'es5',
    'es6',
    'es7',
  ];

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, viewport-fit=cover" />
        <link rel="preconnect" href="//polyfill.io" />
        <link rel="dns-prefetch" href="//polyfill.io" />
        <script
          defer
          src={`https://polyfill.io/v3/polyfill.min.js?features=${defaultPolyfillFeatures.concat(customPolyfillFeatures).join(',')}&flags=gated`}
        />
      </Head>
      <IntlProvider
        locale={locale}
        messages={messages}
      >
        <IntlContext.Consumer>
          {intl => (
            <NuDSProvider
              {...props}
              formatMessage={customFormatMessage({
                cmsMessages,
                formatMessage: intl.formatMessage,
              })}
              locale={intl.locale}
              messages={intl.messages}
              requireImageFunction={requireImage}
              backgroundImageFunction={backgroundImage}
            >
              <ExperimentsContextProvider availableExperiments={availableExperiments}>
                {children}
              </ExperimentsContextProvider>
            </NuDSProvider>
          )}
        </IntlContext.Consumer>
      </IntlProvider>
    </>
  );
}

const { formatMessage, messages, ...nuDSProviderPropTypes } = nuDSProviderShape;

WebsiteProvider.propTypes = {
  ...nuDSProviderPropTypes,
  availableExperiments: PropTypes.arrayOf(PropTypes.object),
  customPolyfillFeatures: PropTypes.arrayOf(PropTypes.string),
  messages: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ),
};

WebsiteProvider.defaultProps = {
  availableExperiments: [],
  customPolyfillFeatures: [],
  messages: {},
};

export default WebsiteProvider;
